import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
  light?: boolean;
};
export function Countdown({
  className = '',
  light = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['seg', seconds % 60]];
  return <div className={`inline-flex items-start gap-2 rounded-lg border px-4 py-2 font-mono font-black ${light ? 'border-sage/60 bg-forest text-onDark' : 'border-line bg-white text-forest'} ${className}`} aria-label="Tiempo restante de la oferta" data-id="element-260" data-mp="1jidav7j285qy">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-261" data-mp="38tdptyj34h4z" data-mpi={index}>
          {index > 0 && <span className="pt-1 text-xl opacity-40" data-id="element-262" data-mp="34tve9td5liet">:</span>}
          <span className="flex min-w-[38px] flex-col items-center leading-none" data-id="element-263" data-mp="34vodinlft0cs">
            <b className="text-xl" data-id="element-264" data-mp="2c75cik5kueeu">{String(value).padStart(2, '0')}</b>
            <small className="mt-1 font-sans text-[9px] font-bold uppercase tracking-wider opacity-70" data-id="element-265" data-mp="2h5yscj8c6hi6">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}